module.exports = __webpack_public_path__ + "static/media/heart-broken.9991c149.svg";